import { render, staticRenderFns } from "./portal-template-updated.vue?vue&type=template&id=7790b2de&"
import script from "./portal-template-updated.vue?vue&type=script&lang=ts&"
export * from "./portal-template-updated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports